import { generateClasses } from '../../utilities/components/styles';
import { isMobile, isTablet, mediaBreakpointDown, mergeWithComponentCustomizedStyles, sizes } from "conversional-theme";
export var Styles = function (theme, options) {
    var _a, _b, _c;
    if (options === void 0) { options = {}; }
    var spacing = options.breadcrumbSpacing;
    if (isMobile())
        spacing -= 20;
    else if (isTablet())
        spacing -= 10;
    var stepBg = options.stepBg, activeStepBg = options.activeStepBg;
    return mergeWithComponentCustomizedStyles(theme, 'questionSteps', {
        stepsContainer: {
            padding: '10px 0',
            margin: '0',
            display: 'flex',
            position: 'relative',
            fontFamily: theme.typo.fonts.regular
        },
        step: (_a = {
                marginRight: "".concat(spacing * 1.15, "px"),
                height: "".concat(2 * spacing, "px"),
                flexGrow: 1,
                lineHeight: '50px',
                background: "".concat(stepBg),
                textAlign: 'center',
                position: 'relative',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ":before": {
                    content: '""',
                    borderLeft: "".concat(spacing, "px solid transparent"),
                    borderTop: "".concat(spacing, "px solid ").concat(stepBg),
                    borderBottom: "".concat(spacing, "px solid ").concat(stepBg),
                    borderRight: '0',
                    position: 'absolute',
                    left: "-".concat(spacing - 1, "px")
                },
                ":nth-child(1)::before": {
                    display: "none"
                },
                ":last-child::after": {
                    display: "none"
                },
                ":last-child": {
                    marginRight: 0
                },
                ":after": {
                    content: '""',
                    borderLeft: "".concat(spacing, "px solid ").concat(stepBg),
                    borderTop: "".concat(spacing, "px solid transparent"),
                    borderBottom: "".concat(spacing, "px solid transparent"),
                    borderRight: '0',
                    position: 'absolute',
                    right: "-".concat(spacing - 1, "px")
                }
            },
            _a[mediaBreakpointDown(sizes.xs)] = {
                fontSize: 14
            },
            _a),
        activeBackground: {
            background: "".concat(activeStepBg),
            ":after": {
                borderLeftColor: "".concat(activeStepBg)
            },
            ":before": {
                borderTopColor: "".concat(activeStepBg),
                borderBottomColor: "".concat(activeStepBg)
            }
        },
        activeStep: (_b = {},
            _b[mediaBreakpointDown(sizes.xs)] = {
                padding: "0 ".concat(spacing * 2, "px")
            },
            _b),
        clickableStep: {
            cursor: 'pointer',
            ":hover": {
                opacity: 0.5
            }
        },
        stepTitle: (_c = {},
            _c[mediaBreakpointDown(sizes.xs)] = {
                display: "none"
            },
            _c.whiteSpace = "nowrap",
            _c.overflow = "hidden",
            _c.textOverflow = "ellipsis",
            _c.marginLeft = 4,
            _c),
        activeStepTitle: {
            display: "block !important"
        }
    });
};
export var renderClasses = function (theme, options) { return generateClasses(function () { return Styles(theme, options); })(theme); };
